"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaterFuseFault = exports.CondenserSensorOpen = exports.CondenserSensorClosed = exports.FloodSensorOpen = exports.ColdSensorClosed = exports.ColdSensorOpen = exports.HotSensorClosed = exports.HotSensorOpen = exports.WaterSupplyFailure = exports.CompressorOverRun = exports.WaterLeak = exports.InterfaceFault = exports.PowerBoardFault = exports.SafetyTimeout = exports.FlowMeterExceed = exports.Overuse = exports.OutOfRange = exports.TouchFreeFault = exports.TemperatureOutOfRange = exports.TankUVCLedFault = exports.NWtr = exports.LowCons = exports.LeakBottomBB = exports.LeakBottom = exports.LeakBB = exports.IceBathWaterLevelFault = exports.IceBathIceThickness = exports.HotTankTimeout = exports.HotTankOh = exports.HotTankFault = exports.HotNTC = exports.HighTDS = exports.FirewallFault = exports.DryHeat = exports.DripNPres = exports.DripFull = exports.DispensedFailed = exports.ConsumableOverused = exports.ConsumableLowLevel = exports.ConsumableExpired = exports.ConsumableDepleted = exports.CompressorTimeout = exports.CompressorFault = exports.ColdNTC = exports.BottleWashFailed = exports.AlarmDomain = exports.AlarmUser = exports.Severity = exports.SendingStyle = exports.NAMESPACE = void 0;
exports.Alarm = exports.consumable_alarms = exports.alarmsByDomain = exports.AlarmTag = exports.alarms = exports.OnOffTransducerDisconnected = exports.MachineError = exports.InSensorFaulty = exports.HighInTemperature = exports.LowInTemperature = exports.HighPumpPressure = exports.LowPumpPressure = exports.InPressure = exports.RoConductance = exports.InConductance = exports.LowFlow = exports.Flooding = exports.UvCommsError = exports.UvOverCurrent = exports.UvUnderCurrent = exports.UvOverTemp = exports.UvNotPresent = exports.ColdTankTimeout = exports.HtbHotTankTimeout = exports.BoilDryProtection = exports.CompressorFuse = exports.HotTankOverfilled = exports.OverSteamed = exports.SteamSensorClosed = exports.SteamSensorOpen = exports.SteamTooCool = exports.PumpFaulty = exports.CondenserOvertemp = exports.HotSensorDegraded = exports.CompressorDriverFault = exports.HeaterDriverFault = void 0;
const effect_1 = require("effect");
const date_1 = require("../../../date");
const user_1 = require("../../user");
const definition_1 = require("./consumable/definition");
exports.NAMESPACE = 'Culligan.Device.Capability.Alarm';
exports.SendingStyle = effect_1.Schema.Literal('immediate', 'stored').annotations({
    identifier: `${exports.NAMESPACE}.SendingStyle`,
});
exports.Severity = effect_1.Schema.Literal('critical', 'non-critical').annotations({
    identifier: `${exports.NAMESPACE}.Severity`,
});
exports.AlarmUser = effect_1.Schema.Union(user_1.DataManagementUserRole, user_1.BasicUserRole).annotations({
    identifier: `${exports.NAMESPACE}.AlarmUser`,
});
exports.AlarmDomain = effect_1.Schema.Literal('Sanitization', 'DripTrayLeak', 'WaterQuality', 'Heating', 'Chilling', 'Consumable', 'SystemFault').annotations({
    identifier: `${exports.NAMESPACE}.AlarmDomain`,
    description: 'Device subsystem/capability domain for alarm categorization',
});
const BaseConsumableParams = effect_1.Schema.Struct({
    consumableId: effect_1.Schema.Literal(...effect_1.Record.values(definition_1.Definitions).map(c => c.id)),
    subsetId: effect_1.Schema.NonEmptyString,
    index: effect_1.Schema.propertySignature(effect_1.Schema.NonNegative).annotations({
        description: 'slot number',
    }),
});
class BottleWashFailed extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.BottleWashFailed`)('bottleWashFailed', {}, { identifier: `${exports.NAMESPACE}.BottleWashFailed`, title: 'Bottle Wash Failed' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Sanitization';
    static roles = ['admin'];
    static description = 'A bottle washing action failed';
    static example = new this();
}
exports.BottleWashFailed = BottleWashFailed;
BottleWashFailed;
class ColdNTC extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.ColdNTC`)('cold_ntc', {}, {
    identifier: `${exports.NAMESPACE}.ColdNTC`,
    title: 'Cold NTC',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'sysAdmin',
        'user',
        'brandTechOperator',
    ];
    static description = 'When NTC is out of resistance range';
    static example = new this();
}
exports.ColdNTC = ColdNTC;
ColdNTC;
class CompressorFault extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.CompressorFault`)('comp_fault', {}, {
    identifier: `${exports.NAMESPACE}.CompressorFault`,
    title: 'Compressor Fault',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'sysAdmin',
        'user',
        'brandTechOperator',
    ];
    static description = 'Compressor was not able to decrease the cold temperature by 2C° in 20 minutes';
    static example = new this();
}
exports.CompressorFault = CompressorFault;
CompressorFault;
class CompressorTimeout extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.CompressorTimeout`)('comp_timeout', {}, {
    identifier: `${exports.NAMESPACE}.CompressorTimeout`,
    title: 'Compressor Timeout',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'sysAdmin',
        'user',
        'brandTechOperator',
    ];
    static description = 'Compressor did not reach target temperature in 180 mins';
    static example = new this();
}
exports.CompressorTimeout = CompressorTimeout;
CompressorTimeout;
class ConsumableDepleted extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.ConsumableDepleted`)('consumableDepleted', {
    params: BaseConsumableParams,
}, {
    identifier: `${exports.NAMESPACE}.ConsumableDepleted`,
    title: 'Consumable Depleted',
}) {
    is(alarm) {
        return (alarm instanceof this.constructor &&
            alarm.params.consumableId === this.params.consumableId &&
            alarm.params.index === this.params.index &&
            alarm.params.subsetId === this.params.subsetId);
    }
    static sendingStyle = 'stored';
    static severity = 'non-critical';
    static domain = 'Consumable';
    static roles = [
        'admin',
        'sysAdmin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
    ];
    static description = 'When a consumable with a capacity has reached the end of life.';
    static example = new this({
        params: {
            consumableId: 'liquid_enhancement',
            subsetId: 'cucu',
            index: 1,
        },
    });
}
exports.ConsumableDepleted = ConsumableDepleted;
ConsumableDepleted;
class ConsumableExpired extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.ConsumableExpired`)('consumableExpired', {
    params: BaseConsumableParams.pipe(effect_1.Schema.extend(effect_1.Schema.Struct({
        expirationDate: date_1.Timestamp,
    }))),
}, {
    identifier: `${exports.NAMESPACE}.ConsumableExpired`,
    title: 'Consumable Expired',
}) {
    is(alarm) {
        return (alarm instanceof this.constructor &&
            alarm.params.consumableId === this.params.consumableId &&
            alarm.params.index === this.params.index &&
            alarm.params.subsetId === this.params.subsetId &&
            alarm.params.expirationDate.getTime() === this.params.expirationDate.getTime());
    }
    static sendingStyle = 'stored';
    static severity = 'non-critical';
    static domain = 'Consumable';
    static roles = [
        'admin',
        'sysAdmin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
    ];
    static description = 'When a consumable (e.g. flavours) with an expiration date reaches that date';
    static example = new this({
        params: {
            consumableId: 'liquid_enhancement',
            subsetId: 'cucu',
            expirationDate: new Date(),
            index: 1,
        },
    });
}
exports.ConsumableExpired = ConsumableExpired;
ConsumableExpired;
class ConsumableLowLevel extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.ConsumableLowLevel`)('consumableLow', {
    params: BaseConsumableParams,
}) {
    is(alarm) {
        return (alarm instanceof this.constructor &&
            alarm.params.consumableId === this.params.consumableId &&
            alarm.params.index === this.params.index &&
            alarm.params.subsetId === this.params.subsetId);
    }
    static sendingStyle = 'stored';
    static severity = 'non-critical';
    static domain = 'Consumable';
    static roles = [
        'admin',
        'sysAdmin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
    ];
    static description = 'When a consumable with a capacity has only 20% of its life left';
    static example = new this({
        params: {
            consumableId: 'liquid_enhancement',
            subsetId: 'cucu',
            index: 1,
        },
    });
}
exports.ConsumableLowLevel = ConsumableLowLevel;
ConsumableLowLevel;
class ConsumableOverused extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.ConsumableOverused`)('consumableOverused', {
    params: BaseConsumableParams,
}, {
    identifier: `${exports.NAMESPACE}.ConsumableOverused`,
    title: 'Consumable Overused',
}) {
    is(alarm) {
        return (alarm instanceof this.constructor &&
            alarm.params.consumableId === this.params.consumableId &&
            alarm.params.index === this.params.index &&
            alarm.params.subsetId === this.params.subsetId);
    }
    static sendingStyle = 'stored';
    static severity = 'non-critical';
    static domain = 'Consumable';
    static roles = [
        'admin',
        'sysAdmin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
    ];
    static description = 'When an expendable consumable reaches its full usage.';
    static example = new this({
        params: {
            consumableId: 'carbon_block',
            subsetId: 'c_block',
            index: 1,
        },
    });
}
exports.ConsumableOverused = ConsumableOverused;
ConsumableOverused;
class DispensedFailed extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.DispensedFailed`)('dispensedFailed', {}, { identifier: `${exports.NAMESPACE}.DispensedFailed`, title: 'Dispense Failed' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'SystemFault';
    static roles = ['admin'];
    static description = 'Deprecated. Use the Event of the same name instead.';
    static example = new this();
}
exports.DispensedFailed = DispensedFailed;
DispensedFailed;
class DripFull extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.DripFull`)('dripFull', {}, { identifier: `${exports.NAMESPACE}.DripFull`, title: 'Drip Tray Full' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'stored';
    static severity = 'non-critical';
    static domain = 'DripTrayLeak';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static description = 'Drip Tray is full, unit OPM changed to blocked';
    static example = new this();
}
exports.DripFull = DripFull;
DripFull;
class DripNPres extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.DripNPres`)('dripnpres', {}, { identifier: `${exports.NAMESPACE}.DripNPres`, title: 'Drip Tray Removed' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'critical';
    static domain = 'DripTrayLeak';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static description = 'When drip tray has been removed, unit goes to OP Fault';
    static example = new this();
}
exports.DripNPres = DripNPres;
DripNPres;
class DryHeat extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.DryHeat`)('dry_heat', {}, { identifier: `${exports.NAMESPACE}.DryHeat`, title: 'Dry Heat' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static description = 'In the event of no water in the hot tank';
    static example = new this();
}
exports.DryHeat = DryHeat;
DryHeat;
class FirewallFault extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.FirewallFault`)('firewallfault', {}, { identifier: `${exports.NAMESPACE}.FirewallFault`, title: 'Firewall Fault' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Sanitization';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static description = 'Firewall self-diagnosis sensor did not detect adequate UV light';
    static example = new this();
}
exports.FirewallFault = FirewallFault;
FirewallFault;
class HighTDS extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HighTDS`)('highTds', {
    params: effect_1.Schema.Struct({
        tds: effect_1.Schema.optionalWith(effect_1.Schema.NonNegative, { exact: true }),
        psi: effect_1.Schema.optionalWith(effect_1.Schema.NonNegative, { exact: true }),
    }),
}, { identifier: `${exports.NAMESPACE}.HighTDS`, title: 'High TDS' }) {
    is(alarm) {
        return (alarm instanceof this.constructor &&
            alarm.params.tds === this.params.tds &&
            alarm.params.psi === this.params.psi);
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'WaterQuality';
    static roles = ['admin', 'sysAdmin'];
    static description = 'The post-treatment TDS is too high';
    static example = new this({
        params: {
            tds: 1,
            psi: 1,
        },
    });
}
exports.HighTDS = HighTDS;
HighTDS;
class HotNTC extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HotNTC`)('hot_ntc', {}, { identifier: `${exports.NAMESPACE}.HotNTC`, title: 'Hot NTC' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'sysAdmin',
        'user',
        'brandTechOperator',
    ];
    static description = 'The resistance of the NTC is out of range';
    static example = new this();
}
exports.HotNTC = HotNTC;
HotNTC;
class HotTankFault extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HotTankFault`)('hot_fault', {}, {
    identifier: `${exports.NAMESPACE}.HotTankFault`,
    title: 'Hot Tank Fault',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'critical';
    static domain = 'Heating';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'sysAdmin',
        'user',
        'brandTechOperator',
    ];
    static description = 'Hot Tank was not able to increase the hot temperature by 2C° in 10 minutes';
    static example = new this();
}
exports.HotTankFault = HotTankFault;
HotTankFault;
class HotTankOh extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HotTankOh`)('hot_tank_oh', {}, { identifier: `${exports.NAMESPACE}.HotTankOh`, title: 'Hot Tank Overheat' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'critical';
    static domain = 'Heating';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'sysAdmin',
        'user',
        'brandTechOperator',
    ];
    static description = 'If thermistor and overload fails, overheating can occur and OP goes to Fault';
    static example = new this();
}
exports.HotTankOh = HotTankOh;
HotTankOh;
class HotTankTimeout extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HotTankTimeout`)('hot_timeout', {}, {
    identifier: `${exports.NAMESPACE}.HotTankTimeout`,
    title: 'Hot Tank Timeout',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'sysAdmin',
        'user',
        'brandTechOperator',
    ];
    static description = 'Hot Tank did not reach target temperature in 30 minutes';
    static example = new this();
}
exports.HotTankTimeout = HotTankTimeout;
HotTankTimeout;
class IceBathIceThickness extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.IceBathIceThickness`)('ice_thi_err', {}, { identifier: `${exports.NAMESPACE}.IceBathIceThickness`, title: 'Ice Bath Ice Thickness' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'sysAdmin',
        'user',
        'brandTechOperator',
    ];
    static description = 'The ice layer within the ice bath is either too thick or not thick enough';
    static example = new this();
}
exports.IceBathIceThickness = IceBathIceThickness;
IceBathIceThickness;
class IceBathWaterLevelFault extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.IceBathWaterLevelFault`)('ice_lev_err', {}, { identifier: `${exports.NAMESPACE}.IceBathWaterLevelFault`, title: 'Ice Bath Water Level Fault' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'sysAdmin',
        'user',
        'brandTechOperator',
    ];
    static description = 'The level of water within the ice bath is too low';
    static example = new this();
}
exports.IceBathWaterLevelFault = IceBathWaterLevelFault;
IceBathWaterLevelFault;
class LeakBB extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.LeakBB`)('leakBb', {}, { identifier: `${exports.NAMESPACE}.LeakBB`, title: 'Leak Blackbox' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'critical';
    static domain = 'DripTrayLeak';
    static roles = ['admin', 'brandManager', 'brandSupportOperator'];
    static description = 'Leak inside the blackbox plastic box';
    static example = new this();
}
exports.LeakBB = LeakBB;
LeakBB;
class LeakBottom extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.LeakBottom`)('leakBottom', {}, { identifier: `${exports.NAMESPACE}.LeakBottom`, title: 'Leak Bottom' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'stored';
    static severity = 'critical';
    static domain = 'DripTrayLeak';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static description = 'Leak detected at the bottom of the unit, OPM changed to blocked';
    static example = new this();
}
exports.LeakBottom = LeakBottom;
LeakBottom;
class LeakBottomBB extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.LeakBottomBB`)('leakBottomBb', {}, { identifier: `${exports.NAMESPACE}.LeakBottomBB`, title: 'Leak Bottom Blackbox' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'stored';
    static severity = 'critical';
    static domain = 'DripTrayLeak';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static description = 'Leak detected inside the Blackbox';
    static example = new this();
}
exports.LeakBottomBB = LeakBottomBB;
LeakBottomBB;
class LowCons extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.LowCons`)('low_cons', {}, { identifier: `${exports.NAMESPACE}.LowCons`, title: 'Low Consumable' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'stored';
    static severity = 'non-critical';
    static domain = 'Consumable';
    static roles = ['sysAdmin'];
    static description = 'Low Consumable';
    static example = new this();
}
exports.LowCons = LowCons;
LowCons;
class NWtr extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.NWtr`)('n_wtr', {}, { identifier: `${exports.NAMESPACE}.NWtr`, title: 'No Water' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'stored';
    static severity = 'critical';
    static domain = 'WaterQuality';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static description = 'No water dispensed when expected';
    static example = new this();
}
exports.NWtr = NWtr;
NWtr;
class TankUVCLedFault extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.TankUVCLedFault`)('uvc_fault', {}, {
    identifier: `${exports.NAMESPACE}.TankUVCLedFault`,
    title: 'Tank UVC Led Fault',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'stored';
    static severity = 'non-critical';
    static domain = 'Sanitization';
    static roles = ['admin', 'sysAdmin'];
    static description = 'Tank UVC Led is not working';
    static example = new this();
}
exports.TankUVCLedFault = TankUVCLedFault;
TankUVCLedFault;
class TemperatureOutOfRange extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.TemperatureOutOfRange`)('temp_ofr', {}, { identifier: `${exports.NAMESPACE}.TemperatureOutOfRange`, title: 'Temperature Out Of Range' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'stored';
    static severity = 'critical';
    static domain = 'SystemFault';
    static roles = ['admin'];
    static description = 'Temperature is out of range';
    static example = new this();
}
exports.TemperatureOutOfRange = TemperatureOutOfRange;
TemperatureOutOfRange;
class TouchFreeFault extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.TouchFreeFault`)('tf_fault', {}, { identifier: `${exports.NAMESPACE}.TouchFreeFault`, title: 'Touch Free Fault' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'stored';
    static severity = 'critical';
    static domain = 'SystemFault';
    static roles = ['admin'];
    static description = 'The touch-free sensor is non-responsive';
    static example = new this();
}
exports.TouchFreeFault = TouchFreeFault;
TouchFreeFault;
class OutOfRange extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.OutOfRange`)('outOfRange', {
    params: effect_1.Schema.Struct({
        telemetryId: effect_1.Schema.String,
        value: effect_1.Schema.Union(effect_1.Schema.Boolean, effect_1.Schema.Number, effect_1.Schema.String),
    }),
}, { identifier: `${exports.NAMESPACE}.OutOfRange`, title: 'Out Of Range' }) {
    is(alarm) {
        return (alarm instanceof this.constructor && alarm.params.telemetryId === this.params.telemetryId);
    }
    static sendingStyle = 'immediate';
    static severity = 'critical';
    static domain = 'SystemFault';
    static roles = ['admin', 'sysAdmin'];
    static description = 'Measure is out of range';
    static example = new this({
        params: {
            telemetryId: 'Pressure',
            value: 100,
        },
    });
}
exports.OutOfRange = OutOfRange;
OutOfRange;
class Overuse extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Overuse`)('overuse', {
    params: effect_1.Schema.Struct({
        waterDispensedVolume: effect_1.Schema.optionalWith(effect_1.Schema.NonNegative, { exact: true }),
        lowerTemp: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    }),
}, { identifier: `${exports.NAMESPACE}.Overuse`, title: 'Overuse' }) {
    is(alarm) {
        return (alarm instanceof this.constructor &&
            alarm.params.waterDispensedVolume === this.params.waterDispensedVolume &&
            alarm.params.lowerTemp === this.params.lowerTemp);
    }
    static sendingStyle = 'stored';
    static severity = 'non-critical';
    static domain = 'SystemFault';
    static roles = ['admin', 'sysAdmin'];
    static description = 'The unit has been used over the expected usage';
    static example = new this({
        params: {
            waterDispensedVolume: 100,
            lowerTemp: 1,
        },
    });
}
exports.Overuse = Overuse;
Overuse;
class FlowMeterExceed extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.FlowMeterExceed`)('flowMeterExceed', {
    params: effect_1.Schema.Struct({
        pulsesPerSecond: effect_1.Schema.Positive.pipe(effect_1.Schema.optionalWith({ exact: true })),
    }),
}, { identifier: `${exports.NAMESPACE}.FlowMeterExceed`, title: 'Flow Meter Exceeded' }) {
    is(alarm) {
        return (alarm instanceof this.constructor &&
            alarm.params.pulsesPerSecond === this.params.pulsesPerSecond);
    }
    static sendingStyle = 'stored';
    static severity = 'non-critical';
    static domain = 'WaterQuality';
    static roles = ['admin', 'sysAdmin'];
    static description = 'The number of pulses over time reported by the flow meter exceed operational limits';
    static example = new this({
        params: {
            pulsesPerSecond: 100,
        },
    });
}
exports.FlowMeterExceed = FlowMeterExceed;
FlowMeterExceed;
class SafetyTimeout extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.SafetyTimeout`)('safetyTimeout', {
    params: effect_1.Schema.Struct({
        component: effect_1.Schema.Literal('solenoid', 'pump', 'heater').pipe(effect_1.Schema.optionalWith({ exact: true })),
    }),
}, { identifier: `${exports.NAMESPACE}.SafetyTimeout`, title: 'Safety Timeout' }) {
    is(alarm) {
        return alarm instanceof this.constructor && alarm.params.component === this.params.component;
    }
    static sendingStyle = 'stored';
    static severity = 'non-critical';
    static domain = 'SystemFault';
    static roles = ['admin', 'sysAdmin'];
    static description = 'A component has been perpetually active for longer than allowed';
    static example = new this({
        params: {
            component: 'heater',
        },
    });
}
exports.SafetyTimeout = SafetyTimeout;
SafetyTimeout;
class PowerBoardFault extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.PowerBoardFault`)('powerBoardFault', {}, { identifier: `${exports.NAMESPACE}.PowerBoardFault`, title: 'Power Board Fault' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'SystemFault';
    static roles = ['admin'];
    static description = 'The communication line between the Power Board and LCD is OK but the power board is not responding to the LCDs requests';
    static example = new this();
}
exports.PowerBoardFault = PowerBoardFault;
PowerBoardFault;
class InterfaceFault extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.InterfaceFault`)('interfaceFault', {}, { identifier: `${exports.NAMESPACE}.InterfaceFault`, title: 'Interface Fault' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'SystemFault';
    static roles = ['admin'];
    static description = 'The communication line that is shared between the Power board and LCD controller is not functioning.';
    static example = new this();
}
exports.InterfaceFault = InterfaceFault;
InterfaceFault;
class WaterLeak extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.WaterLeak`)('waterLeak', {}, { identifier: `${exports.NAMESPACE}.WaterLeak`, title: 'Water Leak' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'DripTrayLeak';
    static roles = ['admin'];
    static description = 'Water detected on the flood sensor due to tank overfill or internal/external leakage.';
    static example = new this();
}
exports.WaterLeak = WaterLeak;
WaterLeak;
class CompressorOverRun extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.CompressorOverRun`)('compressorOverRun', {}, { identifier: `${exports.NAMESPACE}.CompressorOverRun`, title: 'Compressor Over Run' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = ['admin'];
    static description = '"Compressor has been running continously for:\n- sparkling unit: 35min\n- non sparkling unit: 1hr plus a few successive 30min attempts"';
    static example = new this();
}
exports.CompressorOverRun = CompressorOverRun;
CompressorOverRun;
class WaterSupplyFailure extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.WaterSupplyFailure`)('waterSupplyFailure', {}, { identifier: `${exports.NAMESPACE}.WaterSupplyFailure`, title: 'Water Supply Failure' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'SystemFault';
    static roles = ['admin'];
    static description = `1) Hot solenoid on for 5min when water defined as being on an empty level
2) Hot solenoid on for 45min at any level
3) Cold solenoid on for 45min (non-sparkling units)
4) For sparkling units: If sparkling pump is on and cold level rod doesnt detect water for 2min`;
    static example = new this();
}
exports.WaterSupplyFailure = WaterSupplyFailure;
WaterSupplyFailure;
class HotSensorOpen extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HotSensorOpen`)('hotSensorOpen', {}, { identifier: `${exports.NAMESPACE}.HotSensorOpen`, title: 'Hot Sensor Open' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = ['admin'];
    static description = 'An open circuit detected on the hot NTC input';
    static example = new this();
}
exports.HotSensorOpen = HotSensorOpen;
HotSensorOpen;
class HotSensorClosed extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HotSensorClosed`)('hotSensorClosed', {}, { identifier: `${exports.NAMESPACE}.HotSensorClosed`, title: 'Hot Sensor Closed' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = ['admin'];
    static description = 'A short circuit detected on the hot NTC input or hot temperature detected >110°C';
    static example = new this();
}
exports.HotSensorClosed = HotSensorClosed;
HotSensorClosed;
class ColdSensorOpen extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.ColdSensorOpen`)('coldSensorOpen', {}, { identifier: `${exports.NAMESPACE}.ColdSensorOpen`, title: 'Cold Sensor Open' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = ['admin'];
    static description = 'An open circuit detected on the cold NTC input';
    static example = new this();
}
exports.ColdSensorOpen = ColdSensorOpen;
ColdSensorOpen;
class ColdSensorClosed extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.ColdSensorClosed`)('coldSensorClosed', {}, { identifier: `${exports.NAMESPACE}.ColdSensorClosed`, title: 'Cold Sensor Closed' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = ['admin'];
    static description = 'A short circuit detected on the cold NTC input or cold temperature detected >82°C';
    static example = new this();
}
exports.ColdSensorClosed = ColdSensorClosed;
ColdSensorClosed;
class FloodSensorOpen extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.FloodSensorOpen`)('floodSensorOpen', {}, { identifier: `${exports.NAMESPACE}.FloodSensorOpen`, title: 'Flood Sensor Open' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'DripTrayLeak';
    static roles = ['admin'];
    static description = 'A connection to the flood sensor has been lost';
    static example = new this();
}
exports.FloodSensorOpen = FloodSensorOpen;
FloodSensorOpen;
class CondenserSensorClosed extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.CondenserSensorClosed`)('condenserSensorClosed', {}, { identifier: `${exports.NAMESPACE}.CondenserSensorClosed`, title: 'Condenser Sensor Closed' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = ['admin'];
    static description = 'A short circuit detected on the condensor NTC input';
    static example = new this();
}
exports.CondenserSensorClosed = CondenserSensorClosed;
CondenserSensorClosed;
class CondenserSensorOpen extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.CondenserSensorOpen`)('condenserSensorOpen', {}, { identifier: `${exports.NAMESPACE}.CondenserSensorOpen`, title: 'Condenser Sensor Open' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = ['admin'];
    static description = 'An open circuit detected on the condensor NTC input';
    static example = new this();
}
exports.CondenserSensorOpen = CondenserSensorOpen;
CondenserSensorOpen;
class HeaterFuseFault extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HeaterFuseFault`)('heaterFuseFault', {}, { identifier: `${exports.NAMESPACE}.HeaterFuseFault`, title: 'Heater Fuse Fault' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = ['admin'];
    static description = 'No voltage on output driver (element triac) when attempting to turn on element';
    static example = new this();
}
exports.HeaterFuseFault = HeaterFuseFault;
HeaterFuseFault;
class HeaterDriverFault extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HeaterDriverFault`)('heaterDriverFault', {}, { identifier: `${exports.NAMESPACE}.HeaterDriverFault`, title: 'Heater Driver Fault' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = ['admin'];
    static description = 'Voltage on output driver (element triac) detected when element should be turned off';
    static example = new this();
}
exports.HeaterDriverFault = HeaterDriverFault;
HeaterDriverFault;
class CompressorDriverFault extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.CompressorDriverFault`)('compressorDriverFault', {}, { identifier: `${exports.NAMESPACE}.CompressorDriverFault`, title: 'Compressor Driver Fault' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = ['admin'];
    static description = 'Voltage on output driver (compressor triac) detected when compressor should be turned off';
    static example = new this();
}
exports.CompressorDriverFault = CompressorDriverFault;
CompressorDriverFault;
class HotSensorDegraded extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HotSensorDegraded`)('hotSensorDegraded', {}, { identifier: `${exports.NAMESPACE}.HotSensorDegraded`, title: 'Hot Sensor Degraded' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = ['admin'];
    static description = 'Steam NTC is >80°C and hot NTC is 6°C less than steam NTC for more than 1min';
    static example = new this();
}
exports.HotSensorDegraded = HotSensorDegraded;
HotSensorDegraded;
class CondenserOvertemp extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.CondenserOvertemp`)('condenserOvertemp', {}, { identifier: `${exports.NAMESPACE}.CondenserOvertemp`, title: 'Condenser Overtemp' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = ['admin'];
    static description = 'Temperature of condensor has exceeded 72.5°C.';
    static example = new this();
}
exports.CondenserOvertemp = CondenserOvertemp;
CondenserOvertemp;
class PumpFaulty extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.PumpFaulty`)('pumpFaulty', {}, { identifier: `${exports.NAMESPACE}.PumpFaulty`, title: 'Pump Faulty' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = ['admin'];
    static description = 'Too high current detected by pump current sensor';
    static example = new this();
}
exports.PumpFaulty = PumpFaulty;
PumpFaulty;
class SteamTooCool extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.SteamTooCool`)('steamTooCool', {}, { identifier: `${exports.NAMESPACE}.SteamTooCool`, title: 'Steam Too Cool' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = ['admin'];
    static description = 'Boiling calibration has timed out where steam NTC is 6°C less than hot NTC';
    static example = new this();
}
exports.SteamTooCool = SteamTooCool;
SteamTooCool;
class SteamSensorOpen extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.SteamSensorOpen`)('steamSensorOpen', {}, { identifier: `${exports.NAMESPACE}.SteamSensorOpen`, title: 'Steam Sensor Open' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = ['admin'];
    static description = 'An open circuit detected on the NTC input';
    static example = new this();
}
exports.SteamSensorOpen = SteamSensorOpen;
SteamSensorOpen;
class SteamSensorClosed extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.SteamSensorClosed`)('steamSensorClosed', {}, { identifier: `${exports.NAMESPACE}.SteamSensorClosed`, title: 'Steam Sensor Closed' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = ['admin'];
    static description = 'A short circuit detected on the NTC input';
    static example = new this();
}
exports.SteamSensorClosed = SteamSensorClosed;
SteamSensorClosed;
class OverSteamed extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.OverSteamed`)('overSteamed', {}, { identifier: `${exports.NAMESPACE}.OverSteamed`, title: 'Over Steamed' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = ['admin'];
    static description = 'Steam NTC exceeds maximum steam NTC value obtained during last succesful boiling calibration';
    static example = new this();
}
exports.OverSteamed = OverSteamed;
OverSteamed;
class HotTankOverfilled extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HotTankOverfilled`)('hotTankOverfilled', {}, { identifier: `${exports.NAMESPACE}.HotTankOverfilled`, title: 'Hot Tank Overfilled' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = ['admin'];
    static description = 'Boiling tank top level water rod has detected water';
    static example = new this();
}
exports.HotTankOverfilled = HotTankOverfilled;
HotTankOverfilled;
class CompressorFuse extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.CompressorFuse`)('compressorFuse', {}, { identifier: `${exports.NAMESPACE}.CompressorFuse`, title: 'Compressor Fuse' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = ['admin'];
    static description = 'No voltage on output driver (compressor triac) when attempting to turn on compressor';
    static example = new this();
}
exports.CompressorFuse = CompressorFuse;
CompressorFuse;
class BoilDryProtection extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.BoilDryProtection`)('boilDryProtection', {}, { identifier: `${exports.NAMESPACE}.BoilDryProtection`, title: 'Boil Dry Protection' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = ['admin'];
    static description = 'Hot tank NTC is 8°C less than hot setpoint, hot solenoid is not open, hot tank NTC has not increased by 4°C in 5min';
    static example = new this();
}
exports.BoilDryProtection = BoilDryProtection;
BoilDryProtection;
// Prefixed due to naming conflict with pre-existing `HotTankTimeout` alarm
class HtbHotTankTimeout extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HtbHotTankTimeout`)('hotTankTimeout', {}, { identifier: `${exports.NAMESPACE}.HtbHotTankTimeout`, title: 'HTB Hot Tank Timeout' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Heating';
    static roles = ['admin'];
    static description = 'Hot tank is taking more than 240sec to fill during the tank flush step';
    static example = new this();
}
exports.HtbHotTankTimeout = HtbHotTankTimeout;
HtbHotTankTimeout;
class ColdTankTimeout extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.ColdTankTimeout`)('coldTankTimeout', {}, { identifier: `${exports.NAMESPACE}.ColdTankTimeout`, title: 'Cold Tank Timeout' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Chilling';
    static roles = ['admin'];
    static description = 'Cold tank is taking more than 160sec to fill during the tank flush step';
    static example = new this();
}
exports.ColdTankTimeout = ColdTankTimeout;
ColdTankTimeout;
class UvNotPresent extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.UvNotPresent`)('uvNotPresent', {}, { identifier: `${exports.NAMESPACE}.UvNotPresent`, title: 'UV Not Present' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Sanitization';
    static roles = ['admin'];
    static description = 'UV IO PCB does not detect the USBC cable plugged in';
    static example = new this();
}
exports.UvNotPresent = UvNotPresent;
UvNotPresent;
class UvOverTemp extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.UvOverTemp`)('uvOverTemp', {}, { identifier: `${exports.NAMESPACE}.UvOverTemp`, title: 'UV Over Temp' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Sanitization';
    static roles = ['admin'];
    static description = 'The UV disinfector is reporting that its internal temperature is greater than 55 °C';
    static example = new this();
}
exports.UvOverTemp = UvOverTemp;
UvOverTemp;
class UvUnderCurrent extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.UvUnderCurrent`)('uvUnderCurrent', {}, { identifier: `${exports.NAMESPACE}.UvUnderCurrent`, title: 'UV Under Current' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Sanitization';
    static roles = ['admin'];
    static description = 'Tried to dispense cold water and current of UV disinfector not at minimum threshold';
    static example = new this();
}
exports.UvUnderCurrent = UvUnderCurrent;
UvUnderCurrent;
class UvOverCurrent extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.UvOverCurrent`)('uvOverCurrent', {}, { identifier: `${exports.NAMESPACE}.UvOverCurrent`, title: 'UV Over Current' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Sanitization';
    static roles = ['admin'];
    static description = 'Tried to dispense cold water and current of UV filter greater than maximum threshold';
    static example = new this();
}
exports.UvOverCurrent = UvOverCurrent;
UvOverCurrent;
class UvCommsError extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.UvCommsError`)('uvCommsError', {}, { identifier: `${exports.NAMESPACE}.UvCommsError`, title: 'UV Comms Error' }) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'Sanitization';
    static roles = ['admin'];
    static description = 'No communication to the UV IO PCB';
    static example = new this();
}
exports.UvCommsError = UvCommsError;
UvCommsError;
class Flooding extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Flooding`)('flooding', {}, {
    identifier: `${exports.NAMESPACE}.Flooding`,
    title: 'Flooding',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'DripTrayLeak';
    static roles = ['admin'];
    static description = 'Flooding';
    static example = new this();
}
exports.Flooding = Flooding;
Flooding;
class LowFlow extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.LowFlow`)('lowFlow', {}, {
    identifier: `${exports.NAMESPACE}.LowFlow`,
    title: 'Low flow',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'WaterQuality';
    static roles = ['admin'];
    static description = 'Low flow';
    static example = new this();
}
exports.LowFlow = LowFlow;
LowFlow;
class InConductance extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.InConductance`)('inConductance', {}, {
    identifier: `${exports.NAMESPACE}.InConductance`,
    title: 'IN Conductivity',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'WaterQuality';
    static roles = ['admin'];
    static description = 'IN Conductivity';
    static example = new this();
}
exports.InConductance = InConductance;
InConductance;
class RoConductance extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.RoConductance`)('roConductance', {}, {
    identifier: `${exports.NAMESPACE}.RoConductance`,
    title: 'RO Conductivity',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'WaterQuality';
    static roles = ['admin'];
    static description = 'RO Conductivity';
    static example = new this();
}
exports.RoConductance = RoConductance;
RoConductance;
class InPressure extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.InPressure`)('inPressure', {}, {
    identifier: `${exports.NAMESPACE}.InPressure`,
    title: 'IN pressure',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'WaterQuality';
    static roles = ['admin'];
    static description = 'IN pressure';
    static example = new this();
}
exports.InPressure = InPressure;
InPressure;
class LowPumpPressure extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.LowPumpPressure`)('lowPumpPressure', {}, {
    identifier: `${exports.NAMESPACE}.LowPumpPressure`,
    title: 'Low pump pressure',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'SystemFault';
    static roles = ['admin'];
    static description = 'Low pump pressure';
    static example = new this();
}
exports.LowPumpPressure = LowPumpPressure;
LowPumpPressure;
class HighPumpPressure extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HighPumpPressure`)('highPumpPressure', {}, {
    identifier: `${exports.NAMESPACE}.HighPumpPressure`,
    title: 'High pump pressure',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'SystemFault';
    static roles = ['admin'];
    static description = 'High pump pressure';
    static example = new this();
}
exports.HighPumpPressure = HighPumpPressure;
HighPumpPressure;
class LowInTemperature extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.LowInTemperature`)('lowInTemperature', {}, {
    identifier: `${exports.NAMESPACE}.LowInTemperature`,
    title: 'Low IN temperature',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'SystemFault';
    static roles = ['admin'];
    static description = 'Low IN temperature';
    static example = new this();
}
exports.LowInTemperature = LowInTemperature;
LowInTemperature;
class HighInTemperature extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.HighInTemperature`)('highInTemperature', {}, {
    identifier: `${exports.NAMESPACE}.HighInTemperature`,
    title: 'High IN temperature',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'SystemFault';
    static roles = ['admin'];
    static description = 'High IN temperature';
    static example = new this();
}
exports.HighInTemperature = HighInTemperature;
HighInTemperature;
class InSensorFaulty extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.InSensorFaulty`)('inSensorFaulty', {}, {
    identifier: `${exports.NAMESPACE}.InSensorFaulty`,
    title: 'IN sensor faulty',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'SystemFault';
    static roles = ['admin'];
    static description = 'IN sensor faulty';
    static example = new this();
}
exports.InSensorFaulty = InSensorFaulty;
InSensorFaulty;
class MachineError extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.MachineError`)('machineError', {}, {
    identifier: `${exports.NAMESPACE}.MachineError`,
    title: 'Machine error',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'SystemFault';
    static roles = ['admin'];
    static description = 'Machine error';
    static example = new this();
}
exports.MachineError = MachineError;
MachineError;
class OnOffTransducerDisconnected extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.OnOffTransducerDisconnected`)('onOffTransducerDisconnected', {}, {
    identifier: `${exports.NAMESPACE}.OnOffTransducerDisconnected`,
    title: 'ON/OFF transducer disconnected',
}) {
    is(alarm) {
        return alarm instanceof this.constructor;
    }
    static sendingStyle = 'immediate';
    static severity = 'non-critical';
    static domain = 'SystemFault';
    static roles = ['admin'];
    static description = 'ON/OFF transducer disconnected';
    static example = new this();
}
exports.OnOffTransducerDisconnected = OnOffTransducerDisconnected;
OnOffTransducerDisconnected;
exports.alarms = {
    BottleWashFailed,
    ColdNTC,
    CompressorFault,
    CompressorTimeout,
    ConsumableDepleted,
    ConsumableExpired,
    ConsumableLowLevel,
    ConsumableOverused,
    DispensedFailed,
    DripFull,
    DripNPres,
    DryHeat,
    FirewallFault,
    HighTDS,
    HotNTC,
    HotTankFault,
    HotTankOh,
    HotTankTimeout,
    IceBathIceThickness,
    IceBathWaterLevelFault,
    LeakBB,
    LeakBottom,
    LeakBottomBB,
    LowCons,
    NWtr,
    OutOfRange,
    Overuse,
    TankUVCLedFault,
    TemperatureOutOfRange,
    TouchFreeFault,
    FlowMeterExceed,
    SafetyTimeout,
    PowerBoardFault,
    InterfaceFault,
    WaterLeak,
    CompressorOverRun,
    WaterSupplyFailure,
    HotSensorOpen,
    HotSensorClosed,
    ColdSensorOpen,
    ColdSensorClosed,
    FloodSensorOpen,
    CondenserSensorClosed,
    CondenserSensorOpen,
    HeaterFuseFault,
    HeaterDriverFault,
    CompressorDriverFault,
    HotSensorDegraded,
    CondenserOvertemp,
    PumpFaulty,
    SteamTooCool,
    SteamSensorOpen,
    SteamSensorClosed,
    OverSteamed,
    HotTankOverfilled,
    CompressorFuse,
    BoilDryProtection,
    HtbHotTankTimeout,
    ColdTankTimeout,
    UvNotPresent,
    UvOverTemp,
    UvUnderCurrent,
    UvOverCurrent,
    UvCommsError,
    Flooding,
    LowFlow,
    InConductance,
    RoConductance,
    InPressure,
    LowPumpPressure,
    HighPumpPressure,
    LowInTemperature,
    HighInTemperature,
    InSensorFaulty,
    MachineError,
    OnOffTransducerDisconnected,
};
exports.AlarmTag = effect_1.Schema.Union(...effect_1.Record.values(exports.alarms).map(alarmSchema => effect_1.Schema.Literal(alarmSchema._tag))).annotations({
    identifier: `${exports.NAMESPACE}.AlarmTag`,
    title: 'Alarm tag',
});
/**
 * Lookup from {@link AlarmDomain} to the alarm classes that belong to it.
 *
 * Consumers (UI, API handlers) can expand a high-level domain selection — e.g.
 * "Heating" — into the concrete list of {@link AlarmTag} values that the
 * database can filter on. Without this lookup, every call-site filtering by
 * domain would have to hard-code the tag list, which would silently rot
 * whenever a new alarm class is added.
 *
 * Derived from {@link alarms} and each class's `domain` static field; adding a
 * new alarm does not require touching this map.
 */
exports.alarmsByDomain = effect_1.Record.fromEntries(exports.AlarmDomain.literals.map((domain) => [
    domain,
    effect_1.Record.values(exports.alarms).filter(a => a.domain === domain),
]));
exports.consumable_alarms = {
    ConsumableDepleted,
    ConsumableExpired,
    ConsumableLowLevel,
    ConsumableOverused,
};
exports.Alarm = effect_1.Schema.Union(...effect_1.Record.values(exports.alarms)).annotations({
    identifier: `${exports.NAMESPACE}.Alarm`,
    title: 'Alarm',
});
//# sourceMappingURL=alarm.js.map